<script lang="ts">
  import { pauseScheduledSync } from '#lib/services/sync/sync.ts';
  import { listenForUpdates } from '#lib/services/updates/updateListener.ts';
  import { toast } from '#lib/services/ui/toast.svelte.ts';
  import { onMount } from 'svelte';

  let isRestarting = $state(false);

  onMount(async () => {
    listenForUpdates(({ restart }) => {
      toast.info('A new app version is available. Do you want to update and restart the app now?', {
        action: {
          label: 'Restart now',
          onClick: async () => {
            isRestarting = true;
            pauseScheduledSync();
            restart();
          },
        },
        persistent: true,
      });
    });
  });
</script>

{#if isRestarting}
  <div
    class="flex justify-center items-center fixed top-0 bottom-0 left-0 right-0 z-9999 bg-surface-100/50 backdrop-blur-xs"
  >
    <div
      class="w-24 h-24 border-8 border-surface-900-100 border-t-transparent! rounded-full animate-spin"
    ></div>
  </div>
{/if}
